var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingRibbonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking-ribbon-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5313 1.18395L13.7793 3.64195H15.9063C16.1459 3.6361 16.3646 3.77778 16.4573 3.99887C16.5499 4.21996 16.4975 4.47523 16.3253 4.64195L14.3723 6.55995L15.4543 9.04496C15.5521 9.27834 15.4899 9.54811 15.2998 9.71512C15.1096 9.88212 14.8341 9.90903 14.6153 9.78195L12.0003 8.31096L9.38528 9.78195C9.16644 9.90903 8.8909 9.88212 8.70079 9.71512C8.51067 9.54811 8.44847 9.27834 8.54628 9.04496L9.62828 6.55995L7.67528 4.63795C7.50304 4.47123 7.45064 4.21596 7.54328 3.99487C7.63592 3.77378 7.85463 3.6321 8.09428 3.63795H10.2213L11.4703 1.18395C11.5742 0.987298 11.7784 0.864258 12.0008 0.864258C12.2232 0.864258 12.4274 0.987298 12.5313 1.18395Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M5.25028 2.35792C5.02588 2.35655 4.82026 2.48302 4.72028 2.68392L3.47128 5.14192H1.34428C1.10463 5.13607 0.885918 5.27775 0.793281 5.49883C0.700644 5.71992 0.75304 5.9752 0.925276 6.14192L2.87828 8.05992L1.80028 10.5449C1.70247 10.7783 1.76467 11.0481 1.95479 11.2151C2.1449 11.3821 2.42044 11.409 2.63928 11.2819L5.25028 9.81092L5.94228 10.1999",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M18.7506 2.35792C18.975 2.35655 19.1806 2.48302 19.2806 2.68392L20.5296 5.14192H22.6566C22.8962 5.13607 23.115 5.27775 23.2076 5.49883C23.3002 5.71992 23.2478 5.9752 23.0756 6.14192L21.1226 8.05992L22.2006 10.5449C22.2984 10.7783 22.2362 11.0481 22.0461 11.2151C21.856 11.3821 21.5804 11.409 21.3616 11.2819L18.7506 9.81092L18.0586 10.1999",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M0.75 13.7671V16.7671C0.75 16.7671 3.75 13.7671 12 13.7671C20.25 13.7671 23.25 16.7671 23.25 16.7671V13.7671",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M2.64 18.5389C2.20916 19.2707 1.54288 19.8348 0.75 20.1389H2.25C3.07843 20.1389 3.75 20.8105 3.75 21.6389V23.1389C3.75 23.1389 7.79 22.4549 8.208 16.6289",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M21.36 18.5389C21.7908 19.2707 22.4571 19.8348 23.25 20.1389H21.75C20.9216 20.1389 20.25 20.8105 20.25 21.6389V23.1389C20.25 23.1389 16.21 22.4549 15.792 16.6289",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingRibbonIcon);
export default __webpack_public_path__ + "static/media/rankingRibbonIcon.c65639c097565375e56c1bceee5cfa28.svg";
export { ForwardRef as ReactComponent };